import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getLocationHardwareTenantOwnedItemListData,
  getLocationHardwareTenantOwnedItemListDataByLocationId,
} from './mockData'
import type { ILocationHardwareTenantOwnedItem } from '~/types/location/models'

interface GetLocationHardwareTenantOwnedItemsResponse {
  data: ILocationHardwareTenantOwnedItem[]
}

async function getListDataByLocationId(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  console.log(
    `'Returning locationHardwareTenantOwnedItems for location "${id}".`
  )
  const responseBody: GetLocationHardwareTenantOwnedItemsResponse = {
    data: await getLocationHardwareTenantOwnedItemListDataByLocationId(id),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postLocationHardwareTenantOwnedItem = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(
    req,
    res,
    ctx,
    getLocationHardwareTenantOwnedItemListData
  )
}

const patchLocationHardwareTenantOwnedItem = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(
    req,
    res,
    ctx,
    getLocationHardwareTenantOwnedItemListData
  )
}

const deleteLocationHardwareTenantOwnedItem = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(
    req,
    res,
    ctx,
    getLocationHardwareTenantOwnedItemListData
  )
}

export const handlers = [
  {
    method: 'get',
    path: '/api/locationhardwaretenantowneditems/:id',
    handler: getListDataByLocationId,
  },
  {
    method: 'post',
    path: '/api/locationhardwaretenantowneditems',
    handler: postLocationHardwareTenantOwnedItem,
  },
  {
    method: 'patch',
    path: '/api/locationhardwaretenantowneditems/:id',
    handler: patchLocationHardwareTenantOwnedItem,
  },
  {
    method: 'delete',
    path: '/api/locationhardwaretenantowneditems/:id',
    handler: deleteLocationHardwareTenantOwnedItem,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
